import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${theme.spacing['2xl']} ${theme.spacing['2xl']} ${theme.spacing['3xl']};
  background-color: ${theme.semantic.surface.primary};
  box-shadow: 0 -${pxToRem(8)} ${pxToRem(10)} 0 rgb(0 0 0 / 6%);
`;
export const Content = styled.div `
  width: 100%;
  max-width: ${pxToRem(500)};
  margin: auto;
`;
export const Header = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
`;
export const Copy = styled.p `
  margin: 0 0 ${theme.spacing['2xl']};
  font-size: ${theme.fontSize.small};
  line-height: 1.7;

  a {
    color: currentcolor;

    &:hover {
      color: ${theme.swatches.warm[500]};
    }
  }
`;
